// Report Status constants (all 6 statuses from ReportStatusBadge)
export const REPORT_STATUS = {
  SUBMITTED: 'Submitted',
  IN_PROGRESS: 'In progress',
  RECEIVED: 'Received',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
  NEED_INFORMATION: 'Need information',
} as const;

export type ReportStatus = (typeof REPORT_STATUS)[keyof typeof REPORT_STATUS];

const BLACK_HEX = '#000000';
const WHITE_HEX = '#FFFFFF';

export const REPORT_STATUS_COLORS: Record<
  ReportStatus,
  { bg: string; text: string }
> = {
  Submitted: { bg: '#5BC9E1', text: BLACK_HEX },
  'In progress': { bg: '#FFD420', text: BLACK_HEX },
  Received: { bg: '#5BC9E1', text: BLACK_HEX },
  Resolved: { bg: '#00851F', text: WHITE_HEX },
  Closed: { bg: '#969696', text: BLACK_HEX },
  'Need information': { bg: '#D70D0D', text: WHITE_HEX },
};

// Report status display order for dropdowns/lists
export const REPORT_STATUS_ORDER: ReportStatus[] = [
  REPORT_STATUS.SUBMITTED,
  REPORT_STATUS.RECEIVED,
  REPORT_STATUS.IN_PROGRESS,
  REPORT_STATUS.NEED_INFORMATION,
  REPORT_STATUS.RESOLVED,
  REPORT_STATUS.CLOSED,
];

// Report Workflow Step labels (for VerticalStepper)
export const REPORT_WORKFLOW_STEP_LABELS = {
  SUBMITTED: 'Report submitted',
  IN_PROGRESS: 'In progress',
  NEED_INFORMATION: 'Need more information',
  RESOLVED: 'Report resolved',
  RECEIVED: 'Report submitted',
  CLOSED: 'Report closed',
} as const;

// Vertical Step Status (synced with VerticalStepper component)
export const VERTICAL_STEP_STATUS = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  PENDING: 'pending',
} as const;

export type VerticalStepStatus =
  (typeof VERTICAL_STEP_STATUS)[keyof typeof VERTICAL_STEP_STATUS];

export const REPORTS_WITH_STATUS_UPDATES = [
  'Overflowing street bin',
  'Damaged or dirty bin',
  'Dumped Rubbish',
  'Graffiti',
  'Pavement damage',
  'Road damage',
  'Street cleansing',
  'Street lights',
  'Drains',
  'Safety fences and barriers',
  'Signs and bollards',
  'Dead animal removal',
];

export const statusMapping: Record<string, ReportStatus> = {
  New: 'Received',
  InProgress: 'In progress',
  NeedInformation: 'Need information',
  Resolved: 'Resolved',
  Closed: 'Closed',
  Completed: 'Resolved',
};

export const BACK_LINK_LABELS = {
  DASHBOARD: 'Back to myWestminster dashboard',
  REPORTS_LIST: 'Back to all my reports',
};

export const LOADING_REPORTS_MESSAGE = 'Loading reports...';
